import {useCallback} from 'react';

import {GRID_COLUMN_COUNT} from '../../../util/panelbankGrid';

const convertToGridWidth = ({
  columnWidth,
  gridItemMargin,
  w,
}: {
  columnWidth: number;
  gridItemMargin: number[];
  w: number;
}) => {
  const gridWidth = (w + gridItemMargin[0]) / (columnWidth + gridItemMargin[0]);
  return Math.floor(gridWidth);
};

export const convertToGridHeight = ({
  gridItemMargin,
  gridRowHeight,
  h,
}: {
  gridItemMargin: number[];
  gridRowHeight: number;
  h: number;
}) => {
  const gridHeight =
    (h + gridItemMargin[1]) / (gridRowHeight + gridItemMargin[1]);
  return Math.ceil(gridHeight);
};

/**
 * Get grid width and height for the given pixel values
 */
const convertToGridSize = ({
  columnWidth,
  gridItemMargin,
  gridRowHeight,
  height,
  width,
}: {
  columnWidth: number;
  gridItemMargin: number[];
  gridRowHeight: number;
  height: number;
  width: number;
}): {w: number; h: number} => {
  return {
    w: convertToGridWidth({w: width, gridItemMargin, columnWidth}),
    h: convertToGridHeight({
      h: height,
      gridItemMargin,
      gridRowHeight,
    }),
  };
};

export const useResizingSize = ({
  columnWidth,
  gridItemMargin,
  gridRowHeight,
  resizingPixelHeight,
  resizingPixelWidth,
}: {
  columnWidth: number;
  gridItemMargin: number[];
  gridRowHeight: number;
  resizingPixelHeight: number | null;
  resizingPixelWidth: number | null;
}) => {
  const getResizingSize = useCallback(
    (layoutX: number = 0) => {
      if (resizingPixelWidth == null || resizingPixelHeight == null) {
        return null;
      }

      const size = convertToGridSize({
        width: resizingPixelWidth,
        height: resizingPixelHeight,
        gridItemMargin,
        columnWidth,
        gridRowHeight,
      });

      size.w = Math.min(
        size.w,
        GRID_COLUMN_COUNT - layoutX // (layout?.x || 0)
      );

      return {w: Math.max(size.w, 1), h: Math.max(size.h, 2)};
    },
    [
      columnWidth,
      gridItemMargin,
      gridRowHeight,
      resizingPixelHeight,
      resizingPixelWidth,
    ]
  );

  return getResizingSize;
};
